<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{ 'users.usersList.title.shortLabel' | translate }}
                <app-tooltip [text]="'users.usersList.title.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section class="creation-form" *ngIf="isEditAllowed">
            <button *ngIf="!isCreationMode" (click)="onEdit()"
                [matTooltip]="'users.usersList.add.summary' | translate"
                mat-mini-fab class="action-button" color="accent">
                <mat-icon aria-label="Add">person_add</mat-icon>
            </button>
            <app-user-edit *ngIf="isCreationMode && !editedId" (editFinished)="onEditFinished()"></app-user-edit>
        </section>

        <table mat-table [dataSource]="dataSource" multiTemplateDataRows
                matSort matSortActive="username" matSortDirection="asc" matSortDisableClear>
            <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.usersList.username.shortLabel' |
                    translate }} </th>
                <td mat-cell *matCellDef="let user"> {{ user.username }} </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.usersList.email.shortLabel' |
                    translate }} </th>
                <td mat-cell *matCellDef="let user"> {{ user.email }} </td>
            </ng-container>

            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.usersList.role.shortLabel' | translate
                    }} </th>
                <td mat-cell *matCellDef="let user"> {{ user.role.text.shortLabel }} </td>
            </ng-container>

            <ng-container matColumnDef="provider">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.usersList.provider.shortLabel' | translate
                    }} </th>
                <td mat-cell *matCellDef="let user"> {{ getRegion(user.provider) }} </td>
            </ng-container>

            <ng-container matColumnDef="language">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.usersList.language.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let user"> {{ user.language.codeISO }} </td>
            </ng-container>

            <ng-container matColumnDef="lastLogonDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.usersList.lastLogonDate.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let user"> {{ user.lastLogonDate | date }} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> {{ 'users.usersList.actions.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let user">
                    <ng-container *ngIf="user.id !== editedId">
                        <button mat-icon-button class="action-button" color="accent"
                            [matTooltip]="'users.usersList.edit.summary' | translate"
                            *ngIf="!isLoading" (click)="onEdit(user.id)">
                            <mat-icon aria-label="Edit">edit</mat-icon>
                        </button>
                        <button mat-icon-button class="action-button" color="accent"
                            [matTooltip]="'users.usersList.disable.summary' | translate"
                            *ngIf="user.isEnabled && !isLoading"
                            (click)="onChangeState(user, false)">
                            <mat-icon aria-label="Disable">toggle_on</mat-icon>
                        </button>
                        <button mat-icon-button class="action-button" color="primary"
                            [matTooltip]="'users.usersList.enable.summary' | translate"
                            *ngIf="!user.isEnabled && !isLoading"
                            (click)="onChangeState(user, true)">
                            <mat-icon aria-label="Disable">toggle_off</mat-icon>
                        </button>
                        <button mat-icon-button class="action-button" color="accent"
                            *ngIf="!isLoading && (user.lastLogonDate == null && !isSending)"
                            [disabled]="isSending"
                            [matTooltip]="'users.usersList.sendWelcome.summary' | translate"
                            (click)="onSendMail(user)">
                            <mat-icon aria-label="Edit">email</mat-icon>
                        </button>
                        <mat-spinner [diameter]="22" color="accent"
                            *ngIf="isLoading || (user.lastLogonDate == null && isSending)"></mat-spinner>
                    </ng-container>
                </td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let user" [attr.colspan]="displayedColumns.length">
                    <div *ngIf="user.id === editedId" class="user-edit" [@detailExpand]="user.id === editedId ? 'expanded' : 'collapsed'">
                        <app-user-edit [user]="user" (editFinished)="onEditFinished()"></app-user-edit>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                class="user-row"
                [ngClass]="{
                    'disabled': !row.isEnabled,
                    'user-expanded-row': row.id === editedId
                }"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="user-detail-row"></tr>
        </table>
    </mat-card-content>
</mat-card>
